import React, { useState } from "react";
import { Link } from "react-router-dom";
import logoWhite from "../image/logof1.png";
import {
  FaFacebook,
  FaLinkedin,
  FaTwitter,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      if (!email) {
        alert("Please enter your email");
        return;
      }

      const formBody = new URLSearchParams({ email }).toString();

      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbyMcMI5P0rrzMfL6kMVpykZd-LWP3f45O7p3TbC_ulzylKBexSSH-N60RPyjmYzMJtedQ/exec",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formBody,
        }
      );

      const result = await response.json();

      if (result.status === "success") {
        alert("Thank you for subscribing!");
        setEmail("");
      } else {
        alert("❌ Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error(error);
      alert("⚠️ Server error. Please try later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">

        {/* About */}
        <div>
          <img src={logoWhite} alt="GoPhD Logo" className="h-[64px] mb-2" />
          <p className="text-sm text-blue-100 leading-relaxed mb-6">
            Global Diaspora for Public Health Dialogues (G<sup>d</sup>PhD) is a
            healthcare strategy think tank dedicated to fostering evidence-based
            public health dialogues.
          </p>

          <div className="flex space-x-4">
            <a href="https://www.linkedin.com/company/gdphdhealth/" target="_blank" rel="noopener noreferrer" className="bg-blue-800 hover:bg-blue-700 p-2 rounded-full">
              <FaLinkedin />
            </a>
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="bg-blue-800 hover:bg-blue-700 p-2 rounded-full">
              <FaFacebook />
            </a>
            <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" className="bg-blue-800 hover:bg-blue-700 p-2 rounded-full">
              <FaTwitter />
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="bg-blue-800 hover:bg-blue-700 p-2 rounded-full">
              <FaInstagram />
            </a>
            <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" className="bg-blue-800 hover:bg-blue-700 p-2 rounded-full">
              <FaYoutube />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="font-semibold mb-2">Quick Links</h4>
          <ul className="space-y-2 text-sm text-blue-100">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/policy-dialogues">Policy Dialogues Focus</Link></li>
            <li><Link to="/publications">Publications</Link></li>
            <li><Link to="/advisory-board">Advisory Board</Link></li>
            <li><Link to="/events">Events</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-semibold mb-2">Contact Us</h4>
          <p className="text-sm text-blue-100">Lucknow, Uttar Pradesh, India</p>
          <p className="text-sm text-blue-100 mt-2">we@gdphdhealth.org</p>

          <div className="mt-4">
            <h4 className="font-semibold mb-2">Policies</h4>
            <ul className="space-y-2 text-sm text-blue-100">
              <li><Link to="/association">Privacy Policy</Link></li>
              <li><Link to="/association">Disclaimer</Link></li>
              <li><Link to="/association">Terms & Conditions</Link></li>
            </ul>
          </div>
        </div>

        {/* Newsletter */}
        <div>
          <h4 className="font-semibold mb-4">Subscribe</h4>
          <p className="text-sm text-blue-100 mb-4">
            Get updates on policy dialogues & research
          </p>

          <form onSubmit={handleSubmit} className="flex">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              className="px-3 py-2 border rounded-l-md text-sm text-black"
            />
            <button
              type="submit"
              disabled={isSubmitting}
              className="bg-orange-500 px-4 rounded-r-md font-semibold text-sm hover:bg-orange-600 transition disabled:opacity-50"
            >
              {isSubmitting ? "Subscribing..." : "Subscribe"}
            </button>
          </form>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white py-4">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center text-sm text-blue-200">
          <p>© {new Date().getFullYear()} GdPhD. All rights reserved.</p>
          <a
            href="https://www.aksharconsultancy.org/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white"
          >
            Developed and Maintained by Akshar Consultancy Services Pvt. Ltd.
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
